import React, { useState } from 'react'
import TextFieldUniversal from '../../../../../validate/form/text/TextFieldUniversal'

const SeriesInPackNumberFrom = ({ required, setValidate, setValueForm, forciblyValue }) => {

	const [value, setValue] = useState('')

  return (
	<TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'№ товару в партії (початок)'} 
        placeholder={'1'}
        validates={{
            isEmpty: true,
            isDigit: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
    />
  )
}

export default SeriesInPackNumberFrom